
export default {
  name: "PromptDialog",
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Dialog: () => import(/* webpackChunkName: "Dialog" */ "./Dialog"),
  },
  props: {
    show: {
      default: false,
      required: false,
    },
    file: {
      required: true,
      default: Object
    },
    primaryAction: {
      default: () => ({
        text: "Yes",
      }),
      required: false,
    },
    secondaryAction: {
      default: () => ({
        text: "Cancel",
      }),
      required: false,
    }
  },
  data: () => ({
    data: null,
    userFeedback: "",
    userEmail: "",
  }),
  watch: {
    show(val) {
      if (val) {
        this.open();
      } else {
        this.close();
      }
    },
  },
  methods: {
    isValidEmail(email) {
      var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return regex.test(email);
    },
    open(data) {
      this.data = data;
      this.$refs.Dialog.open();
    },
    close() {
      this.data = null;
      this.$refs.Dialog.cancel();
      this.selected_reason = "";
      this.additional_reason = "";
    },
    accept() {
      this.$emit("accept", {
        ...this.data,
        userFeedback: this.userFeedback,
        userEmail: this.userEmail,
      });
      this.$refs.Dialog.close();
      this.userFeedback = "";
      this.userEmail = "";
    },
  },
};
